/*
 * Keeps the sweepstakes entries pill (snippets/shared-sweeps.liquid) in step with the
 * variant a card is showing.
 *
 * The pill is rendered by Liquid from the variant that was selected server-side, so on a
 * card where the shopper can switch colour or size the count would otherwise keep quoting
 * the first variant's price. Every call site that already knows the new price hands it to
 * SweepsEntries.sync(), which redoes the same arithmetic the snippet does:
 *
 *     entries = floor(price_in_dollars * multiplier)
 *
 * The copy around the number is not rebuilt here — the snippet writes it into
 * data-ss-prefix / data-ss-suffix so wording, giveaway name and bonus entries stay in
 * Liquid. A pill without those attributes is left untouched.
 */
(function () {
  'use strict';

  function formatCount(value) {
    // Matches the snippet's manual thousands separators.
    try {
      return value.toLocaleString('en-US');
    } catch (e) {
      return String(value);
    }
  }

  /**
   * @param {Element} root - any element containing one or more entries pills (usually the card).
   * @param {number|string} priceCents - the newly selected variant's price, in cents.
   */
  function sync(root, priceCents) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    // null and '' both coerce to 0, which would silently zero a good pill — reject them.
    if (priceCents === null || priceCents === undefined || priceCents === '') return;

    var cents = Number(priceCents);
    if (!isFinite(cents) || cents < 0) return;

    var banners = root.querySelectorAll('.shared-sweeps-entries-banner');

    for (var i = 0; i < banners.length; i++) {
      var banner = banners[i];
      var count = banner.querySelector('.shared-sweeps-entries-count');
      if (!count) continue;

      var prefix = count.getAttribute('data-ss-prefix');
      var suffix = count.getAttribute('data-ss-suffix');
      if (prefix === null || suffix === null) continue;

      var multiplier = parseFloat(banner.getAttribute('data-multiplier'));
      if (!isFinite(multiplier) || multiplier <= 0) multiplier = 1;

      var entries = Math.floor((cents / 100) * multiplier);
      count.textContent = prefix + formatCount(entries) + suffix;
    }
  }

  window.SweepsEntries = window.SweepsEntries || {};
  window.SweepsEntries.sync = sync;

  /*
   * <product-card> (assets/product-card.js) recalculates its own price on every option
   * change but knows nothing about sweeps. Wrap that one method rather than editing the
   * card script, so the hook survives the card being re-rendered or the script updated.
   * The original runs first and its exceptions still propagate — the pill is refreshed in
   * a finally block so a failure inside the card's own price code cannot strand it.
   */
  function patchProductCard() {
    var ctor = window.customElements && customElements.get('product-card');
    if (!ctor || !ctor.prototype || ctor.prototype.__sweepsEntriesPatched) return;

    var original = ctor.prototype.calculatePrices;
    if (typeof original !== 'function') return;

    ctor.prototype.calculatePrices = function () {
      try {
        return original.apply(this, arguments);
      } finally {
        if (this.selectedVariant) sync(this, this.selectedVariant.price);
      }
    };
    ctor.prototype.__sweepsEntriesPatched = true;
  }

  if (window.customElements) {
    patchProductCard();
    if (!customElements.get('product-card')) {
      customElements.whenDefined('product-card').then(patchProductCard);
    }
  }
})();
